import { Button, CardContent, Grid, Typography } from "@mui/material";
import { FormattedMessage as T } from "react-intl";
import { ImportMode } from "types/commonTypes";

type ImportUsersFileUploadedProps = {
  onClose: () => void;
  onUploadNewFile: () => void;
  mode: ImportMode;
};

export function ImportUsersFileUploaded({
  onClose,
  onUploadNewFile,
  mode,
}: Readonly<ImportUsersFileUploadedProps>) {
  return (
    <>
      <CardContent>
        <Typography component="h2" style={{ marginTop: 10, marginBottom: 15 }}>
          <T
            id={
              mode === "deactivate"
                ? "usersAreBeingDeactivated"
                : "importUsersSuccessMessage"
            }
          />
        </Typography>
      </CardContent>

      <Grid container spacing={2} justifyContent="right">
        <Grid item xs={12} sm={12} md={3}>
          <Button onClick={onUploadNewFile} variant="contained" fullWidth>
            <T id="uploadNewFile" />
          </Button>
        </Grid>
        <Grid item xs={12} sm={12} md={2}>
          <Button onClick={onClose} autoFocus fullWidth>
            <T id="close" />
          </Button>
        </Grid>
      </Grid>
    </>
  );
}
